import type { Timezone } from '@/modules/counterparty/types/timezone.type.ts';

export function findDefaultTimezone(zones: Timezone[]) {
  return zones.find((zone) => zone.name.includes(' +0)')) ?? zones[0] ?? null;
}
